
import { mapActions, mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
	components: {},
	props: {
		meterData: {
			type: Object,
		},
	},
	filters: {
		formatDate(value) {
			return dayjs(value).format('DD.MM.YYYY');
		}
	},
	data() {
		return {
			showSaveBtn: false,
			ruleForm: {
				value: 0,
			},
			rules: {
				value: [
					{
						required: true,
						message: "Це поле не може бути пустим.",
					},
				],
			},
		}
	},
	computed: {
		...mapGetters(['currentUserID', 'contractNumber', 'isAdmin']),
		hasLastIndicator() {
			return !!this.meterData.lastIndicator.value
		}
	},
	mounted() {
		this.ruleForm.value = this.meterData?.lastIndicator?.value || 0
	},
	methods: {
		...mapActions(['saveIndicator', 'getAllMetters', 'getIndicatorsHistory', 'setRefresh', 'deleteMeter']),
		submitMeterValue() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					const meterForm = {
						meterId: this.meterData._id,
						value: this.ruleForm.value,
						createdAt: new Date(),
						contractNumber: this.contractNumber
					}
					this.saveIndicator(meterForm).then(() => {
						this.$notify.success({
							title: 'Успіх!',
							message: 'Показник успішно збережено.',
						});
						this.showSaveBtn = !this.showSaveBtn
						this.getAllMetters({
							userId: this.currentUserID,
							contractNumber: this.contractNumber
						});
						this.setRefresh(true);
					}).catch(() => {
						this.$notify.error({
							title: 'Помилка',
							message: 'Сталася помилка під час збереження показника.',
						});
					});
				}
			});
		},
		clickMeterDelete(id) {
			console.log(id)
			this.deleteMeter({ id }).then(() => {
				this.$notify.success({
					title: 'Успіх!',
					message: 'Лічильник успішно видалено.',
				});
				this.getAllMetters({
					userId: this.currentUserID,
					contractNumber: this.contractNumber
				});
			}).catch(() => {
				this.$notify.error({
					title: 'Помилка',
					message: 'Сталася помилка під час видалення лічильника.',
				});
			});
		}
	},
}